module.exports = __webpack_public_path__ + "static/media/logo_binder_small.08ae118a.jpg";